/*!

=========================================================
* Now UI Dashboard React - v1.5.0
=========================================================

* Product Page: https://www.creative-tim.com/product/now-ui-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/now-ui-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useEffect, useState } from "react";

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Spinner,
} from "reactstrap";
import { BASE_URL } from "../../utils/constants";
import { MDBDataTableV5 } from "mdbreact";
// core components
import PanelHeader from "../../components/PanelHeader/PanelHeader.js";
import Swal from "sweetalert2";
import axios from "axios";
import InterventionModal from "./InterventionModal";

const AcademicInterventions = () => {
  const [p,setP]=useState(false);
  const [modal, setModal] = useState(false);
 const [interventionId , setInterventionId] = useState(0);
 const [modalMode, setModalMode] = useState("request");
  const   [intData, setIntData] = useState({
      columns: [
        {
          label: "#",
          field: "id",
        },
       
        {
          label: "Teacher",
          field: "teacher_name",
        },
        {
          label: "Course",
          field: "coursename",
        },
        {
          label: "Lesson",
          field: "lesson",
        },
        {
          label: "Date",
          field: "date",
        },
        {
          label: "Status",
          field: "status",
        },
        {
          label: "View",
          field: "view",
        },
      
      ],
      rows: [
        {
          id: <Spinner color="info" />,
          teacher_name: <Spinner color="info" />,
          coursename: <Spinner color="info" />,
          lesson: <Spinner color="info" />,
     
          status: <Spinner color="info" />,
          view:<></>
         
        },
      ],
    });
    const handleViewModal=(id )=>{
      setInterventionId(id);
      setModalMode("view");
      setModal(true);
    }

    const handleRequestModal = () => {
      setInterventionId(0);
      setModalMode("request");
      setModal(true);
    };

  useEffect(async () => {
    Swal.showLoading();
    try {
      // waiting for interventions api to get data>>
      let res = await axios.get(`${BASE_URL}/student/academicintervention/getinterventions.php`);
      const academicInterventions = Array.isArray(res.data.data) ? res.data.data : [];
      
      setIntData((prevState) => {
        const newState = { ...prevState };
        let ser = 1;
        // change .exams below to .homeworks and quiz to hmwork after backend finished
        let newRows = academicInterventions.map((i, key) => {
          return {
            ...i,
            id: ser++,
            teacher_name: (i.teacher_name && i.teacher_name.trim()) ? i.teacher_name : "-",
            coursename: (i.coursename && i.coursename.trim()) ? i.coursename : "-",
            lesson: (i.lesson && i.lesson.trim()) ? i.lesson : "-",
            date: i.date || "-",
            status: i.status || "-",
            view: (
              <>
                <button
                  className="btn btn-info text-center fs-6 fw-bold py-1 px-3"
                  onClick={(e) => handleViewModal( i.id)}
                >
                  View
                </button>
              </>
            ),
          };
        });
        return { ...newState, rows: newRows };
      });
    } catch {
      Swal.fire("Something Went Wrong", "", "error");
    } finally {
      Swal.close();
    }
  }, [p]);

  return (
    <>

     <InterventionModal Modal = {modal} setModal={setModal} interventionId={interventionId} mode={modalMode} setP={setP} p ={p} />
      <PanelHeader size="sm" />
      <div className="content">
        <Row>
          <Col md={12}>
            <Card className="w-100">
              <CardHeader>
                <h4 className="title">Academic Interventions</h4>
        <button className="btn btn-primary" onClick ={handleRequestModal}>Request academic intervention</button>
              </CardHeader>
              <CardBody className="all-icons">
                <MDBDataTableV5
                  hover
                  responsive
                  borderless={false}
                  bordered
                  striped
                  entriesOptions={[5, 20, 25]}
                  entries={5}
                  pagesAmount={4}
                  data={intData}
                  fullPagination
                  searchTop
                  searchBottom={false}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>

     
    </>
  );
};

export default AcademicInterventions;
